/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stage_Backdrop_Hero_ImageInputs */

const en_stage_backdrop_hero_image = /** @type {(inputs: Stage_Backdrop_Hero_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stage Backdrop (Hero Image)`)
};

const es_stage_backdrop_hero_image = /** @type {(inputs: Stage_Backdrop_Hero_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fondo de escenario (Imagen Hero)`)
};

const fr_stage_backdrop_hero_image = /** @type {(inputs: Stage_Backdrop_Hero_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toile de fond de la scène (Hero Image)`)
};

const de_stage_backdrop_hero_image = /** @type {(inputs: Stage_Backdrop_Hero_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bühnenhintergrund (Hero-Bild)`)
};

const ja_stage_backdrop_hero_image = /** @type {(inputs: Stage_Backdrop_Hero_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ステージ背景 (ヒーロー画像)`)
};

const zh_stage_backdrop_hero_image = /** @type {(inputs: Stage_Backdrop_Hero_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`舞台背景 (主视觉图)`)
};

const ar_stage_backdrop_hero_image = /** @type {(inputs: Stage_Backdrop_Hero_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خلفية المنصة (صورة رئيسية / Hero)`)
};

const id_stage_backdrop_hero_image = /** @type {(inputs: Stage_Backdrop_Hero_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Latar Belakang Panggung (Gambar Hero)`)
};

const it_stage_backdrop_hero_image = /** @type {(inputs: Stage_Backdrop_Hero_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sfondo della Scena (Immagine Principale)`)
};

const ru_stage_backdrop_hero_image = /** @type {(inputs: Stage_Backdrop_Hero_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Фоновое изображение (Hero Image)`)
};

const pt_stage_backdrop_hero_image = /** @type {(inputs: Stage_Backdrop_Hero_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cenário de Fundo (Hero Image)`)
};

const ko_stage_backdrop_hero_image = /** @type {(inputs: Stage_Backdrop_Hero_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`무대 배경 (히어로 이미지)`)
};

/**
* | output |
* | --- |
* | "Stage Backdrop (Hero Image)" |
*
* @param {Stage_Backdrop_Hero_ImageInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const stage_backdrop_hero_image = /** @type {((inputs?: Stage_Backdrop_Hero_ImageInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stage_Backdrop_Hero_ImageInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_stage_backdrop_hero_image(inputs)
	if (locale === "es") return es_stage_backdrop_hero_image(inputs)
	if (locale === "fr") return fr_stage_backdrop_hero_image(inputs)
	if (locale === "de") return de_stage_backdrop_hero_image(inputs)
	if (locale === "ja") return ja_stage_backdrop_hero_image(inputs)
	if (locale === "zh") return zh_stage_backdrop_hero_image(inputs)
	if (locale === "ar") return ar_stage_backdrop_hero_image(inputs)
	if (locale === "id") return id_stage_backdrop_hero_image(inputs)
	if (locale === "it") return it_stage_backdrop_hero_image(inputs)
	if (locale === "ru") return ru_stage_backdrop_hero_image(inputs)
	if (locale === "pt") return pt_stage_backdrop_hero_image(inputs)
	return ko_stage_backdrop_hero_image(inputs)
});